export default __webpack_public_path__ + "static/top-tier-web-790e7d109841403318fe20bfb85ff3ea.webp";